<template>
  <div v-cloak class="Resource">
    <div class="main">
      <div class="left pa-20">
        <Bread :list="breadList" />
        <div class="flex f-between ma-t-20">
          <div class="fon-20 weight500 t-omit-1">
          {{detail.Name}}
          </div>
            <div @click="toCollection()">
            <img
              src="../img/shoucang.png"
              class="img_25"
              v-if="!detail.IsCollection"
            />
            <img src="../img/shoucang1.png" class="img_25" v-else />
          </div>
        </div>
        <div class="flex  pa-t-10 pa-b-10  c-999">
          <div>
              {{detail.CategoryName}}
          </div>
          <div class="ma-l-40">
            <i class="iconfont icon-shijian"></i>
            {{detail.ReleaseTime}}
          </div>
          <div class="ma-l-40">
            <i class="iconfont icon-yanjing1"></i>
            {{detail.ViewCount}}
          </div>
          <div class="ma-l-40">
            <i class="iconfont icon-guanliyuan"></i>
            {{detail.Author}}
          </div>
        </div>
        <div class="ma-t-20 lh-html" v-html="detail.Content"></div>
        <!-- <div class="pa-20 box-download ma-t-20">
          <div class="boxi-down">
            <div class="text-down">文件下载</div>
            <div class="flex">
              <button class="btn-down"  @click="downFile"><i class="iconfont icon-xiazai"></i> 下载地址</button>
            </div>
          </div>
        </div> -->
        <!-- <div class="flex f-between ma-t-20 b-b-1-e3 pa-b-20">
          <div class="flex">
            <div class="flex f-center "><i class="iconfont icon-zuo"></i></div>
            <div class="ma-l-20">
              <div class="c-999">上一篇</div>
              <div>上一篇标题</div>
            </div>
          </div>
          <div class="flex">
            <div>
              <div class="c-999">下一篇</div>
              <div>下一篇标题</div>
            </div>
            <div class="flex f-center ma-l-20"><i class="iconfont icon-you"></i></div>
          </div>
        </div> -->
        <div class="ma-t-20">
          <div class="bold b-b-2-bold pa-b-10">相关文章</div>
          <div v-for="(item,index) in detail.SimilarList" :key="index" class="b-b-1-e3">
            <div class="flex ma-tb-20 height140px">
              <!-- <div class="w200px">
                <img :src="item.Image" alt="" srcset="" width="100%" height="100%">
              </div> -->
              <div class="ma-l-20 width100 flex flex-direction f-between">
                <div class="blod">{{item.Name}}</div>
                <div class="flex  f-between c-999 ma-t-10 text-overflow3">
                   {{item.Summary}}
                </div>
                <div class="flex f-between">
                  <div class="flex width50 f-between c-999 mt-auto">
                  <div><i class="iconfont icon-shijian"></i>
                  {{item.ReleaseTime}}
                  </div>
                  <div><i class="iconfont icon-yanjing"></i>
                  {{item.ViewCount}}
                  </div>
                  <div><i class="iconfont icon-biaoqian_o"></i>
                  {{item.CategoryName}}
                  </div>
                </div>
                  <button class="btn-reddetail" @click="toDetail(item.Id)">详细阅读 <i class="iconfont icon-you"></i> </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="right pa-tb-20 pa-lr-10">
        <div class="flex b-b-1-e3 pa-b-20">
          <div class="blue_tab ma-r-10 fon-16"></div>
          最新文章
        </div>
        <div v-for="(item,index) in 5" :key="index">
          <div class="pa-t-10 pa-b-10 b-b-1-e3"> <i class="iconfont icon-sanjiaoxing c-999 fon-12"></i> 最新文章标题{{index}}</div>
        </div>
      </div> -->
    </div>
    <!-- 中间内容 -->

  <el-dialog :visible.sync="dialogTableVisible" width="50%">
    <div class="t-center ma-t-20">
      <div class="bg-efeef1 t-left pa-10 b-r-10">
        <div>声明：</div>
        <div >
本站大部分下载资源收集于网络，只做学习和交流使用，版权归原作者所有。<br>
若您需要使用非免费的软件或服务，请购买正版授权并合法使用！<br>
本站发布的内容若侵犯到您的权益，请联系站长删除，我们将及时处理！</div>
      </div>
      <div class="t-center ma-t-10 p-relative">
          <div>请识别二维码进入公众号下载</div>
          <div class="w-30 mlr-auto">
            <img :src="qrCodeUrl" alt="" srcset="" width="100%">
            <img src="../img/logo_i.png" alt="" width="6%" class="img-inside">
          </div>
      </div>
      <div class="t-center c-FF7E00 ma-t-20">
        本站所有资料均为【免费】
      </div>
    </div>
  </el-dialog>
  </div>
</template>
<style lang="scss"  scoped>
    /* 大屏 宽度大于768 */
    @media (min-width: 768px) {
        .img_25 {
            width: 25px;
            height: 25px;
        }

        .w-30 {
            width: 30%;
        }

        .mlr-auto {
            margin: 0 auto;
        }

        .p-relative {
            position: relative;
        }

        .img-inside {
            position: absolute;
            top: 50%;
            left: 50%;
            -webkit-transform: translateX(-50%) translateY(-50%);
            -webkit-transform: translateX(-50%) translateY(-50%);
            -moz-transform: translateX(-50%) translateY(-50%);
            -ms-transform: translateX(-50%) translateY(-50%);
            transform: translateX(-50%) translateY(-50%);
        }

        .c-FF7E00 {
            color: #FF7E00;
        }

        .c-green {
            color: #0A9400;
        }

        .c-blue {
            color: #429DE2;
        }

        .bg-efeef1 {
            background: #efeef1;
        }

        body {
            //   min-width: 1200px;
            background: rgba(245, 247, 250, 1);
        }

        .Resource .swiper {
            width: 100%;
            height: 314px;
            background-image: url(../img/two_1.png);
            background-size: 100% 100%;
            background-repeat: no-repeat;
            position: relative;

            .toptexts {
                width: 736px;
                position: absolute;
                top: 28%;
                margin: 0 auto;
                left: 50%;
                margin-left: -368px;
                font-size: 20px;
                font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                color: #fff;
                opacity: 0.75;
                text-align: center;

                .texts {
                    line-height: 30px;
                    letter-spacing: 3px;
                    font-size: 16px;
                }

                .imgtitle {
                    font-size: 24px;
                    font-weight: bold;
                    margin-bottom: 20px;
                }
            }
        }


        .main {
            width: 1200px;
            margin: 30px auto;
            display: flex;
            justify-content: space-between;

            .left {
                width: 100%;
                background: #fff;
                min-height: 1109px;
            }

            .right {
                width: 371px;
                background: #fff;
                height: 891px !important;

                .right_box {
                    width: 350px;
                    height: 287px;
                    margin: 0 auto;
                    margin-top: 30px;
                    padding: 0 12px 20px;
                    border-bottom: 1px #eee solid !important;

                    & img {
                        width: 335px;
                        height: 199px;
                    }
                }
            }
        }

        .blue_tab {
            width: 4px;
            height: 20px;
            background: #fb004d;
            border-radius: 2px;
        }

        .box-download {
            border: 2px solid #fcab4e;
            background: #fffcef;
        }

        .boxi-down {
            border: 1px solid #eee;
            background: #fff;
            padding: 20px;
        }

        .text-down {
            position: relative;
            top: -30px;
            color: #fcab4e;
            font-weight: bold;
        }

        .btn-down {
            background: #1ba1e2;
            border: none;
            color: #fff;
            width: 180px;
        }

        .c-ffdeb8 {
            color: #fcab4e;
        }

        .b-b-2-bold {
            border-bottom: 2px solid #1ba1e2;
        }

        .w200px {
            width: 200px;
        }

        .btn-reddetail {
            background: rgb(218, 218, 218);
            border: none;
            color: #fff;

            i {
                font-size: 10px;
            }
        }

        .fon-12 {
            font-size: 12px;
        }

        .height140px {
            height: 140px;
        }

        .mt-auto {
            margin-top: auto;
        }
    }
</style>
<script>
import { getDatumDetail, getQrcode,postDatumCollection } from "../api.js"
import Bread from "../components/Bread.vue";

// studycollect
export default {
  name: "read",
  components: {
    Bread,
  },
  props: {},
  data() {
    return {
      qrCodeUrl:'',
      dialogTableVisible:false,
      id: 0,
      detail: {},
      breadList: [
        { name: "服务中心", path: "/Datum" },
        { name: "正文", path: "/read" },
      ],
      html:'<p><img src="https://xqimg.imedao.com/17d9ef0031a2293fd160bcf3.jpg!800.jpg" class="ke_img"></p><p>2019&nbsp;年以来<h-char unicode="ff0c" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>，</h-inner></h-char>美国对我国国内高科技企业的制裁力度不断加大<h-char unicode="ff0c" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>，</h-inner></h-char>数次提高对国内部分高科技企业的限制级别<h-char unicode="ff0c" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>，</h-inner></h-char>尤其在集成电路和&nbsp;EDA&nbsp;工具领域体现的较为明显<h-char unicode="3002" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>。</h-inner></h-char>例如<h-char unicode="ff0c" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>，</h-inner></h-char>2019&nbsp;年&nbsp;EDA&nbsp;三巨头终止了与华为海思的合作<h-char unicode="ff0c" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>，</h-inner></h-char>为国产芯片的发展蒙上了一层阴影<h-char unicode="3002" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>。</h-inner></h-char></p><p>目前<h-char unicode="ff0c" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>，</h-inner></h-char>全球EDA市场主要被<a href="https://xueqiu.com/S/SNPS?from=status_stock_match" class="xq_stock">新思科技</a><h-char unicode="ff08" class="biaodian cjk bd-open bd-jiya"><h-inner>（</h-inner></h-char>Synopsys<h-char unicode="ff09" class="biaodian cjk bd-close bd-end bd-jiya bd-consecutive"><h-inner>）</h-inner></h-char><h-char unicode="3001" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya bd-consecutive end-portion" prev="bd-close bd-end"><h-inner>、</h-inner></h-char>楷登电子<h-char unicode="ff08" class="biaodian cjk bd-open bd-jiya"><h-inner>（</h-inner></h-char>Cadence<h-char unicode="ff09" class="biaodian cjk bd-close bd-end bd-jiya"><h-inner>）</h-inner></h-char>和<a href="https://xueqiu.com/S/SIEGY?from=status_stock_match" class="xq_stock">西门子</a>EDA<h-char unicode="ff08" class="biaodian cjk bd-open bd-jiya"><h-inner>（</h-inner></h-char>Siemens&nbsp;EDA<h-char unicode="ff09" class="biaodian cjk bd-close bd-end bd-jiya"><h-inner>）</h-inner></h-char>三大巨垄断<h-char unicode="ff0c" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>，</h-inner></h-char>这三大巨头占据了全球EDA市场78%的市场份额<h-char unicode="3002" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>。</h-inner></h-char>而在国内市场<h-char unicode="ff0c" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>，</h-inner></h-char>2018-2020&nbsp;年中国国产&nbsp;EDA&nbsp;工具在国内市场销售份额分别为&nbsp;6.2%<h-char unicode="3001" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>、</h-inner></h-char>8.3%<h-char unicode="3001" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>、</h-inner></h-char>11.5%<h-char unicode="ff0c" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>，</h-inner></h-char>尽管市占率逐步提高<h-char unicode="ff0c" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>，</h-inner></h-char>但仍处于较低水平<h-char unicode="ff0c" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>，</h-inner></h-char>可见海外厂商依旧占据绝对优势<h-char unicode="3002" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>。</h-inner></h-char></p><p>在此背景之下<h-char unicode="ff0c" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>，</h-inner></h-char>国内集成电路设计及制造企业开始寻求实现&nbsp;EDA&nbsp;工具软件的进口替代<h-char unicode="3002" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>。</h-inner></h-char>国内&nbsp;EDA&nbsp;厂商也迎来了巨大的发展机遇<h-char unicode="3002" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>。</h-inner></h-char></p><p><br></p><p><b>一<h-char unicode="3001" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>、</h-inner></h-char>EDA&nbsp;基本介绍</b></p><p><b>1<h-char unicode="3001" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>、</h-inner></h-char>EDA&nbsp;是集成电路设计的基础工具</b></p>s<p>EDA<h-char unicode="ff08" class="biaodian cjk bd-open bd-jiya"><h-inner>（</h-inner></h-char>Electronic&nbsp;Design&nbsp;Automation<h-char unicode="ff0c" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>，</h-inner></h-char>电子设计自动化<h-char unicode="ff09" class="biaodian cjk bd-close bd-end bd-jiya"><h-inner>）</h-inner></h-char>是指利用计算机软件完成大规模集成电路的设计<h-char unicode="3001" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>、</h-inner></h-char>仿真<h-char unicode="3001" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>、</h-inner></h-char>验证等流程的设计方式<h-char unicode="ff0c" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>，</h-inner></h-char>融合了图形学<h-char unicode="3001" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>、</h-inner></h-char>计算数学<h-char unicode="3001" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>、</h-inner></h-char>微电子学<h-char unicode="ff0c" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>，</h-inner></h-char>拓扑逻辑学<h-char unicode="3001" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>、</h-inner></h-char>材料学及人工智能等技术<h-char unicode="3002" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>。</h-inner></h-char>随着集成电路产业的发展<h-char unicode="ff0c" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>，</h-inner></h-char>设计规模越来越大<h-char unicode="ff0c" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>，</h-inner></h-char>制造工艺越来越复杂<h-char unicode="ff0c" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>，</h-inner></h-char>设计师依靠手工难以完成相关工作<h-char unicode="ff0c" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>，</h-inner></h-char>必须依靠&nbsp;EDA&nbsp;工具完成电路设计<h-char unicode="3001" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>、</h-inner></h-char>版图设计<h-char unicode="3001" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>、</h-inner></h-char>版图验证<h-char unicode="3001" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>、</h-inner></h-char>性能分析等工作<h-char unicode="3002" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>。</h-inner></h-char>EDA&nbsp;软件作为集成电路领域的上游基础工具<h-char unicode="ff0c" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>，</h-inner></h-char>贯穿于集成电路设计<h-char unicode="3001" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>、</h-inner></h-char>制造<h-char unicode="3001" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>、</h-inner></h-char>封测等环节<h-char unicode="ff0c" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>，</h-inner></h-char>是集成电路产业的战略基础支柱之一<h-char unicode="3002" class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"><h-inner>。</h-inner></h-char></p>'
    };
  },

  created() {
    this.id = this.$route.query.id;
    this.getDetail();
  },
  beforeRouteEnter(to, from, next) {
    window.scroll(0, 0);
    // 判断是否从详情页面回来

    next();
  },

  // 其他页面进来时更新初始数据
  activated() {},

  methods: {
    downFile(){
      // console.log(1)
      getQrcode({id:this.id}).then(res=>{
          if (res.data.Code == 0) {
            this.qrCodeUrl=res.data.Data
            this.dialogTableVisible=true
          }else{
              this.$message.success(res.data.Message);
          }
      })

    },
    login() {
      let token = localStorage.getItem("AccessToken") || "";
      if (!token) {
        this.$confirm("您还未登录请先登录?", "提示", {
          confirmButtonText: "去登录",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push("/login");
          })
          .catch(() => {
            return false;
          });
      } else {
        return true;
      }
    },
    toCollection() {
      if (this.login()) {
        let token = localStorage.getItem("AccessToken") || "";
        let data = {
          Id: this.id,
          Token: token,
        };
        postDatumCollection(data).then((res) => {
          if (res.data.Code == 0) {
            this.detail.IsCollection = !this.detail.IsCollection;
            if (this.detail.IsCollection) {
              this.$message.success("收藏成功");
            } else {
              this.$message.success("已取消收藏");
            }
          }
        });
      }
    },
    getDetail() {
      let data = {
        id: this.id
      };
      getDatumDetail(data).then((res) => {
        if (res.data.Code == 0) {
          this.detail = res.data.Data;
        }
      });
    },

    toDetail(e) {
      this.$router.push({
        path:'/read',
        query:{id:e}
      })
      window.scroll(0, 0);

    },

    upload(e) {
      window.open(e, "_blank");
    },
  },
  watch:{
    $route(o){
      if(o.name=='read' && o.query.id!=this.id ){
       this.id = this.$route.query.id;
       this.getDetail();
      }
    }
  }
};
</script>
